module.exports = __webpack_public_path__ + "img/medMission_041022_A.959a1a6a.jpg";